import React, { useEffect, useState, useMemo, useContext } from 'react'
import { useNavigate } from 'react-router-dom'
import Module from '../../../templates/components/Module'
import SideTabs from '../../../templates/layouts/SideTabs'
import LocationSettings from './location-settings/LocationSettings'
import PracticeSettings from './practice-settings/PracticeSettings'
import ProviderSettings from './provider-settings/ProviderSettings'
import Utilities from '../../../../services/commonservice/utilities'
import SecuritySettings from './security-settings/SecuritySettings'
import FormsSettings from './forms-settings/FormsSettings'
import SchedulingSettings from './scheduling-settings/SchedulingSettings'
import ProductsServicesFeesSettings from './products-services-fees-settings/ProductsServicesFeesSettings'
import PatientSettings from './practice-patient-settings/PatientSettings'
import PaymentSettings from './payment-settings/PaymentSettings'
import { store } from '../../../../context/StateProvider'
const SettingsDashboard = (props) => {
    const globalStateAndDispatch = useContext(store)
    const state = globalStateAndDispatch.state
    const masterRole = useMemo(()=>{
        return Utilities.getMasterRole()
    },[])
    const [activeTab, setActiveTab] = useState()
    const [isUserLogin, setIsUserLogin] = useState(state.providerSelected?.practiceLocationUsers?.length > 0 ? true : false)
    const navigate = useNavigate()
    useEffect(() => {
        changeTab(props.tab)
    }, [props.tab])

    useEffect(() => {
        if(state.providerSelected){
            setIsUserLogin(state.providerSelected?.practiceLocationUsers?.length > 0 ? true : false)
        }
    }, [state.providerSelected])

    const changeTab = (tab) => {
        if (tab === 'practice') {
            if(isUserLogin){
                navigate('/provider/settings/security')
                setActiveTab("security")
            }else{
                navigate('/provider/settings')
                setActiveTab(tab)
            }
        }
        else {
            navigate(`/provider/settings/${tab}`)
            setActiveTab(tab)
        }
    }
    return (
        <SideTabs title="Settings" menuTitle="Settings Menu" contentTitle='Settings' activeKey={activeTab} onSelect={k => changeTab(k)}>
            <Module title="Practice" eventKey="practice" hide={isUserLogin}>
                <PracticeSettings />
            </Module>
            <Module title="Security" eventKey="security">
                <SecuritySettings isUserLogin={isUserLogin}/>
            </Module>
            <Module title="Locations" eventKey="location">
                <LocationSettings isUserLogin={isUserLogin}/>
            </Module>
            <Module title="Patients" eventKey="patients" hide={isUserLogin}>
                <PatientSettings/>
            </Module>
            <Module title="Forms" eventKey="forms" hide={isUserLogin}>
                <FormsSettings/>
            </Module>
            <Module title="Scheduling" eventKey="scheduling">
                <SchedulingSettings isUserLogin={isUserLogin}/>
            </Module>
            <Module title="Products, Services, Fees" eventKey="productsservicesfees">
                <ProductsServicesFeesSettings isUserLogin={isUserLogin}/>
            </Module>
            <Module title="Providers" eventKey="provider" hide={masterRole==3}>
                <ProviderSettings/>
            </Module>
            <Module title="Payments" eventKey="payment" hide={isUserLogin}>
                <PaymentSettings/>
            </Module>
        </SideTabs>
    )

}

export default SettingsDashboard